import { CacheData } from './interfaces';

export default function getSizeBytes(data: CacheData): number {
  // null means no bytes.
  if (!data) {
    return 0;
  }
  // a string in js isn't always one byte per char. So encode it and count the bytes.
  if (typeof data === 'string' || data instanceof String) {
    const encoder = new TextEncoder();
    const buffer = encoder.encode(data as string);
    return buffer.byteLength;
  }
  // byteBuffers and their variants.
  if (data instanceof ArrayBuffer && (data as ArrayBuffer).byteLength) {
    return data.byteLength;
  }
  // an array should return it's length.
  if ((data as number[]).length) {
    return (data as number[]).length;
  }
  // no idea what the data is. So return 0.
  return 0;
}
